@let state = $state();
<cm-asset-grid-cell>
    <cm-asset-cell-chip cm-top-left interactive [cdkMenuTriggerFor]="menuSize">
        Thumbnail
        <i class="far fa-chevron-down"></i>
    </cm-asset-cell-chip>

    <div cm-top-right class="cm-actions-slot">
        @switch (state.kind) {
            @case ("empty") {
                @if ($canEdit() && $hasCyclesMaterial()) {
                    <cm-asset-cell-chip interactive (click)="onRenderSelected()"><i class="far fa-play"></i> Generate</cm-asset-cell-chip>
                }
            }
            @case ("loading") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="onCancelSelected()"><cm-loading-spinner-icon></cm-loading-spinner-icon> Cancel</cm-asset-cell-chip>
                }
            }
            @case ("failed") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="onRetrySelected()"><i class="far fa-rotate-reverse"></i> Retry</cm-asset-cell-chip>
                    <cm-asset-cell-chip interactive (click)="onRemoveSelected()"><i class="far fa-trash-can"></i></cm-asset-cell-chip>
                }
            }
            @case ("complete") {
                @if ($canDownload()) {
                    <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="downloadMenu.menu()">
                        <i class="far fa-arrow-to-bottom"></i>
                    </cm-asset-cell-chip>
                    <cm-asset-download-menu #downloadMenu [dataObject]="state.result" />
                }
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="actionsMenu.menu()">
                        <i class="far fa-ellipsis-v"></i>
                    </cm-asset-cell-chip>
                    <cm-asset-actions-menu #actionsMenu [actions]="actions" (action)="onAction($event)" />
                }
            }
        }
    </div>

    @if (state.kind === "complete") {
        <cm-asset-dimension-overlay [widthLabel]="$selectedSizeDimensionLabel()" [heightLabel]="$selectedSizeDimensionLabel()">
            <img
                class="cm-image cm-clickable"
                [src]="state.result.preview?.downloadUrl ?? state.result.jpeg?.downloadUrl ?? state.result.downloadUrl"
                alt=""
                (click)="preview.emit()"
            />
        </cm-asset-dimension-overlay>
    } @else {
        <cm-asset-dimension-overlay [widthLabel]="$selectedSizeDimensionLabel()" [heightLabel]="$selectedSizeDimensionLabel()">
            <div class="cm-placeholder-image"></div>
        </cm-asset-dimension-overlay>
        @if (state.kind === "empty" && !$hasCyclesMaterial()) {
            <div class="cm-empty-overlay">
                <span class="cm-empty-message">Please create a material to generate outputs.</span>
            </div>
        }
    }
</cm-asset-grid-cell>

<ng-template #menuSize>
    <div cdkMenu class="cm-size-menu">
        @for (size of $sizes(); track size.type) {
            <span
                cdkMenuItem
                class="cm-size-label"
                [class.cm-size-selected]="size.isSelected"
                [class.cm-size-not-generated]="!size.isRendered"
                (cdkMenuItemTriggered)="onSizeMenuClick(size)"
            >
                {{ size.label }}
            </span>
            @if (size.isLoading) {
                @if ($canEdit()) {
                    <span cdkMenuItem class="cm-size-action" (cdkMenuItemTriggered)="onSizeCancelClick(size)">
                        <cm-loading-spinner-icon class="cm-size-icon"></cm-loading-spinner-icon> Cancel
                    </span>
                } @else {
                    <span></span>
                }
            } @else if (!size.isRendered) {
                @if ($canEdit() && $hasCyclesMaterial()) {
                    <span cdkMenuItem class="cm-size-action" (cdkMenuItemTriggered)="onSizeRenderClick(size)">
                        <i class="cm-size-icon far fa-play"></i> Generate
                    </span>
                } @else {
                    <span></span>
                }
            } @else if (size.result && $canDownload()) {
                <span cdkMenuItem class="cm-size-action" [cdkMenuTriggerFor]="sizeDownloadMenu.menu()" [cdkMenuPosition]="sizeDownloadMenuPosition">
                    <i class="cm-size-icon far fa-arrow-to-bottom"></i> Download
                </span>
                <cm-asset-download-menu #sizeDownloadMenu [dataObject]="size.result" />
            } @else {
                <span></span>
            }
        }
    </div>
</ng-template>
